export { StudentLivePage } from "./StudentLivePage"
export type {
    StudentLivePageProps,
    UILiveNotice,
    UILiveScreenNotice,
    UILiveView,
    UILiveWaiting,
} from "./StudentLivePage"
